import useInitializeComplaintAdvancedForm from './useInitializeComplaintAdvancedForm'
export default useInitializeComplaintAdvancedForm
